export default (theme) => ({
  layout: {
    width: '100%',
    minHeight: '100vh',
    height: 1,
  },
})